import {
  EducationMaterialControllerApi,
  UploadEducationMaterialDocumentFormatEnum,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

type EducationMaterialUpdateParam = {
  uuid: string;
  providerId: string;
  name: string;
  description: string;
  condition: string;
  documentFormat: UploadEducationMaterialDocumentFormatEnum;
  specialityId?: string;
  documentDate?: string;
  fileName?: string;
  xTENANTID?: string;
  file?: File;
};

/**
 * @author Rajkumar Rathod
 */
export const useEducationMaterialUpdate = () =>
  useMutationWithLoading(async (params: EducationMaterialUpdateParam) =>
    new EducationMaterialControllerApi(
      getConfigObject()
    ).updateEducationMaterial(
      params?.uuid,
      params?.providerId,
      params?.name,
      params?.description,
      params?.condition,
      params?.documentFormat,
      params?.specialityId,
      params?.documentDate,
      params?.fileName,
      params?.xTENANTID,
      params?.file
    )
  );
